export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0165"] = "acq-0165";
  ExperimentKeys["ACQ0167"] = "acq-0167";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';